/**
 * Whether a validation message is an i18n key (`quote.validations.qty_non_negative`)
 * rather than copy. Schemas and the write boundary name keys; every reader
 * (the Zod error map, `localizeZodIssueMessage`, the model-facing
 * validation errors) localizes them with this test. Dependency-free on
 * purpose: both the i18n instance and the localizer import it.
 */
export function isValidationErrorMessageKey(value: string): boolean {
  return value.includes(".") && !value.includes(" ")
}
